export interface Restaurant {
  name: string
  url: string
}
// eslint-disable-next-line @typescript-eslint/no-var-requires
const data = require('./restaurants.json') as Restaurant[]

export const restaurants: Restaurant[] = data
